module.exports = __webpack_public_path__ + "assets/f3ba8f0ee546593e7a9088a9b854578b.mp3";